// Simple i18n utility - no external dependencies, React 15 compatible
// Usage: import { t, setLang, getLang, onLangChange } from '../../i18n';

const en = {
  // Navigation
  "nav.dashboard": "Dashboard",
  "nav.dashboard.stats": "System Stats",
  "nav.dashboard.car": "CAR",
  "nav.dashboard.creditRisk": "Credit Risk",
  "nav.car": "CAR",
  "nav.car.upload": "Upload File",
  "nav.car.fileManagement": "File Management",
  "nav.car.reports": "Reports",
  "nav.capitalPlanning": "Capital Planning",
  "nav.capitalPlanning.dashboard": "Dashboard",
  "nav.capitalPlanning.report": "Report",
  "nav.icaap": "ICAAP",
  "nav.icaap.upload": "Upload File",
  "nav.icaap.fileManagement": "File Management",
  "nav.icaap.reports": "Reports",
  "nav.masterTable": "Master Table",
  "nav.masterTable.partyType": "Party Type",
  "nav.masterTable.businessSector": "Business Sector",
  "nav.raroc": "RAROC",
  "nav.raroc.upload": "Upload File",
  "nav.raroc.reports": "Reports",
  "nav.raroc.fileManagement": "File Management",
  "nav.pricing": "Pricing",
  "nav.pricing.upload": "Upload",
  "nav.pricing.fileManagement": "File Management",
  "nav.pricing.processing": "Processing",
  "nav.pricing.reports": "Reports",
  "nav.configParameters": "Config Parameters",
  "nav.configParameters.components": "Components",
  "nav.configParameters.assetClass": "Asset Class",
  "nav.configParameters.riskWeight": "Risk Weight",
  "nav.user": "User",
  "nav.role": "Role",
  "nav.reportAccess": "Report Access",
  "nav.activities": "Activities",
  "nav.actionLog": "Action Log",
  "nav.settings": "Settings",
  // Common
  "common.search": "Search",
  "common.filter": "Filter",
  "common.clear": "Clear",
  "common.upload": "Upload",
  "common.download": "Download",
  "common.delete": "Delete",
  "common.save": "Save",
  "common.cancel": "Cancel",
  "common.confirm": "Confirm",
  "common.close": "Close",
  "common.loading": "Loading...",
  "common.noData": "No data available",
  "common.error": "An error occurred",
  "common.success": "Success",
  "common.status": "Status",
  "common.action": "Action",
  "common.date": "Date",
  "common.name": "File Name",
  "common.type": "Type",
  "common.size": "Size",
  // Dashboard
  "dashboard.title": "System Dashboard",
  "dashboard.subtitle": "Overview of all modules and system activity",
  "dashboard.users": "System Users",
  "dashboard.carFiles": "CAR Files",
  "dashboard.icaapFiles": "ICAAP Files",
  "dashboard.rarocFiles": "RAROC Files",
  "dashboard.pricingRecords": "Pricing Records",
  "dashboard.totalFiles": "Total Files",
  "dashboard.recentActivity": "Recent Activity",
  "dashboard.filesByModule": "File Count by Module",
  "dashboard.user": "User",
  "dashboard.activityAction": "Action",
  "dashboard.activityTime": "Time",
  // Upload
  "upload.selectFile": "Select File",
  "upload.dragDrop": "Drag and drop your file here",
  "upload.fileType": "Accepted file types: .xlsx, .xls",
  "upload.inProgress": "Uploading...",
  "upload.complete": "Upload Complete",
  "upload.failed": "Upload Failed",
  // Reports
  "reports.title": "Reports",
  "reports.noReports": "No reports available",
  "reports.download": "Download Report",
  "reports.view": "View Report",
  // Login
  "login.username": "Username",
  "login.password": "Password",
  "login.submit": "Login",
  "login.title": "Sign In",
};

const vi = {
  // Navigation
  "nav.dashboard": "Bảng Điều Khiển",
  "nav.dashboard.stats": "Thống Kê Hệ Thống",
  "nav.dashboard.car": "CAR",
  "nav.dashboard.creditRisk": "Rủi Ro Tín Dụng",
  "nav.car": "CAR",
  "nav.car.upload": "Tải Lên Tệp",
  "nav.car.fileManagement": "Quản Lý Tệp",
  "nav.car.reports": "Báo Cáo",
  "nav.capitalPlanning": "Kế Hoạch Vốn",
  "nav.capitalPlanning.dashboard": "Bảng Điều Khiển",
  "nav.capitalPlanning.report": "Báo Cáo",
  "nav.icaap": "ICAAP",
  "nav.icaap.upload": "Tải Lên Tệp",
  "nav.icaap.fileManagement": "Quản Lý Tệp",
  "nav.icaap.reports": "Báo Cáo",
  "nav.masterTable": "Bảng Danh Mục",
  "nav.masterTable.partyType": "Loại Đối Tượng",
  "nav.masterTable.businessSector": "Ngành Kinh Doanh",
  "nav.raroc": "RAROC",
  "nav.raroc.upload": "Tải Lên Tệp",
  "nav.raroc.reports": "Báo Cáo",
  "nav.raroc.fileManagement": "Quản Lý Tệp",
  "nav.pricing": "Định Giá",
  "nav.pricing.upload": "Tải Lên",
  "nav.pricing.fileManagement": "Quản Lý Tệp",
  "nav.pricing.processing": "Xử Lý",
  "nav.pricing.reports": "Báo Cáo",
  "nav.configParameters": "Cấu Hình Tham Số",
  "nav.configParameters.components": "Thành Phần",
  "nav.configParameters.assetClass": "Nhóm Tài Sản",
  "nav.configParameters.riskWeight": "Trọng Số Rủi Ro",
  "nav.user": "Người Dùng",
  "nav.role": "Vai Trò",
  "nav.reportAccess": "Phân Quyền Báo Cáo",
  "nav.activities": "Hoạt Động",
  "nav.actionLog": "Nhật Ký Hoạt Động",
  "nav.settings": "Cài Đặt",
  // Common
  "common.search": "Tìm kiếm",
  "common.filter": "Lọc",
  "common.clear": "Xóa",
  "common.upload": "Tải Lên",
  "common.download": "Tải Xuống",
  "common.delete": "Xóa",
  "common.save": "Lưu",
  "common.cancel": "Hủy",
  "common.confirm": "Xác Nhận",
  "common.close": "Đóng",
  "common.loading": "Đang tải...",
  "common.noData": "Không có dữ liệu",
  "common.error": "Đã xảy ra lỗi",
  "common.success": "Thành Công",
  "common.status": "Trạng Thái",
  "common.action": "Hành Động",
  "common.date": "Ngày",
  "common.name": "Tên Tệp",
  "common.type": "Loại",
  "common.size": "Kích Thước",
  // Dashboard
  "dashboard.title": "Bảng Điều Khiển Hệ Thống",
  "dashboard.subtitle": "Tổng quan tất cả các module và hoạt động hệ thống",
  "dashboard.users": "Người Dùng Hệ Thống",
  "dashboard.carFiles": "Tệp CAR",
  "dashboard.icaapFiles": "Tệp ICAAP",
  "dashboard.rarocFiles": "Tệp RAROC",
  "dashboard.pricingRecords": "Bản Ghi Định Giá",
  "dashboard.totalFiles": "Tổng Tệp",
  "dashboard.recentActivity": "Hoạt Động Gần Đây",
  "dashboard.filesByModule": "Số Tệp Theo Module",
  "dashboard.user": "Người Dùng",
  "dashboard.activityAction": "Hành Động",
  "dashboard.activityTime": "Thời Gian",
  // Upload
  "upload.selectFile": "Chọn Tệp",
  "upload.dragDrop": "Kéo và thả tệp vào đây",
  "upload.fileType": "Loại tệp chấp nhận: .xlsx, .xls",
  "upload.inProgress": "Đang tải lên...",
  "upload.complete": "Tải Lên Hoàn Tất",
  "upload.failed": "Tải Lên Thất Bại",
  // Reports
  "reports.title": "Báo Cáo",
  "reports.noReports": "Không có báo cáo",
  "reports.download": "Tải Báo Cáo",
  "reports.view": "Xem Báo Cáo",
  // Login
  "login.username": "Tên Đăng Nhập",
  "login.password": "Mật Khẩu",
  "login.submit": "Đăng Nhập",
  "login.title": "Đăng Nhập",
};

const DICTIONARIES = { en, vi };
const STORAGE_KEY = "ey_lang";
const LISTENERS = [];

let _currentLang = localStorage.getItem(STORAGE_KEY) || "en";

export function getLang() {
  return _currentLang;
}

export function setLang(lang) {
  if (DICTIONARIES[lang]) {
    _currentLang = lang;
    localStorage.setItem(STORAGE_KEY, lang);
    LISTENERS.forEach((fn) => fn(lang));
  }
}

export function onLangChange(fn) {
  LISTENERS.push(fn);
  return () => {
    const idx = LISTENERS.indexOf(fn);
    if (idx !== -1) LISTENERS.splice(idx, 1);
  };
}

export function t(key, fallback) {
  const dict = DICTIONARIES[_currentLang] || DICTIONARIES["vi"];
  return dict[key] || fallback || key;
}

export default { t, setLang, getLang, onLangChange };



// WEBPACK FOOTER //
// src/i18n.js